import axios from "axios";
import md5 from "js-md5";
import CryptoJS from 'crypto-js';
// 创建 axios 实例
const request = axios.create({
  baseURL: process.env.VUE_APP_ZEEKR_API_ADDRESS, // 基础url,如果是多环境配置这样写，也可以像下面一行的写死。
  timeout: 60000 // 请求超时时间
})

function encrypt(word, keyStr) {
  keyStr = keyStr ? keyStr : 'platformPassword';
  var key = CryptoJS.enc.Utf8.parse(keyStr);
  var srcs = CryptoJS.enc.Utf8.parse(word);
  var encrypted = CryptoJS.AES.encrypt(srcs, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
  return encrypted.toString();
}

// 错误处理函数
const err = (error) => {
  // dosomething
  return Promise.reject(error)
}

// request interceptor(请求拦截器)
request.interceptors.request.use(config => {
  let body = typeof config.data === 'string' ?
    JSON.parse(config.data) : config.data
  if (!body) body = {}
  const timestamp = new Date().getTime(),
    id = md5(JSON.stringify(body)),
    sign = md5(JSON.stringify(body) + timestamp),
    data = {
      body,
      id,
      sign,
      timestamp,
    }
  let signKey = {
    sign: md5("zeekrgo-subscription" + timestamp),
    timestamp: timestamp
  }
  if (config.method === "post") {
    config.data = data
  }
  let zeekrsign = encrypt(JSON.stringify(signKey), "zeekrgoSubscribe")
  config.headers.zeekrsign = zeekrsign
  
  return config
}, err)

// response interceptor（接收拦截器）
request.interceptors.response.use((response) => {
  return response
}, err)

export default request